const filePicker = (options = {}) => {
    const {
        name = 'fileInput',
        id = `file-picker-${Date.now()}`,
        accept = '.pdf',
        disabled = false,
        placeholder = 'Datei auswählen',
        onFileChange = null,
        validateFile = null,
    } = options

    // Create wrapper container
    const wrapper = document.createElement('div')
    wrapper.className = 'lux-file-picker'
    wrapper.style.cssText = 'position:relative;width:100%;'

    // Inject styles if not already present
    if (!document.getElementById('lux-filepicker-styles')) {
        const style = document.createElement('style')
        style.id = 'lux-filepicker-styles'
        style.textContent = `
            .lux-file-picker {
                box-sizing: border-box;
                padding: 0;
                border: 0.2rem solid rgb(238, 237, 237);
                border-radius: 6px;
                background: #fff;
                display: inline-flex;
                align-items: center;
                width: 100%;
                transition: border-color 0.2s, box-shadow 0.2s;
                cursor: pointer;
            }
            .lux-file-picker:hover {
                border-color: rgb(0, 0, 0);
            }
            .lux-file-picker-text {
                flex: 1;
                padding: 4px 0 4px 11px;
                background: transparent;
                border: none;
                outline: none;
                font-size: 16px;
                line-height: 1.5715;
                color: rgba(0, 0, 0, 0.88);
                font-weight: 500;
                cursor: pointer;
                user-select: none;
            }
            .lux-file-picker-text.empty {
                color: rgba(0, 0, 0, 0.25);
            }
            .lux-file-picker-suffix {
                display: flex;
                align-items: center;
                color: rgba(0, 0, 0, 0.54);
                cursor: pointer;
                padding-right: 11px;
            }
            .lux-file-picker-suffix svg {
                width: 18px;
                height: 18px;
                fill: currentColor;
            }
            .lux-file-picker:disabled,
            .lux-file-picker.disabled {
                background: #f5f5f5;
                border-color: rgb(238, 237, 237);
                cursor: not-allowed;
            }
            .lux-file-picker:disabled .lux-file-picker-text,
            .lux-file-picker.disabled .lux-file-picker-text {
                background: transparent;
                color: rgba(0, 0, 0, 0.25);
                cursor: not-allowed;
            }
        `
        document.head.appendChild(style)
    }

    // Create HTML structure
    wrapper.innerHTML = `
        <div class="lux-file-picker-text empty" id="${id}-text">${placeholder}</div>
        <span class="lux-file-picker-suffix" id="${id}-suffix">
            <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
                <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z"/>
            </svg>
        </span>
        <input type="file" accept="${accept}" id="${id}" name="${name}" style="display: none;" ${disabled ? 'disabled' : ''}/>
    `

    // Get references
    const fileInput = wrapper.querySelector(`#${id}`)
    const filePickerText = wrapper.querySelector(`#${id}-text`)
    const filePickerSuffix = wrapper.querySelector(`#${id}-suffix`)

    // Click handler for entire file picker
    wrapper.addEventListener('click', (e) => {
        e.stopPropagation()
        if (!fileInput.disabled) {
            fileInput.click()
        }
    })

    // Track selected file
    let selectedFile = null
    fileInput.addEventListener('change', (e) => {
        const file = e.target.files[0]
        
        // Validate file if validator provided
        if (file && validateFile) {
            const validationResult = validateFile(file)
            if (validationResult !== true) {
                if (typeof validationResult === 'string') {
                    alert(validationResult)
                }
                fileInput.value = ''
                selectedFile = null
                if (filePickerText) {
                    filePickerText.textContent = placeholder
                    filePickerText.classList.add('empty')
                }
                return
            }
        }

        selectedFile = file
        if (filePickerText) {
            if (file) {
                filePickerText.textContent = file.name
                filePickerText.classList.remove('empty')
            } else {
                filePickerText.textContent = placeholder
                filePickerText.classList.add('empty')
            }
        }

        // Call onFileChange callback if provided
        if (onFileChange) {
            onFileChange(file, selectedFile)
        }
    })

    // Public API
    return {
        wrapper,
        input: fileInput,
        text: filePickerText,
        suffix: filePickerSuffix,
        getFile: () => selectedFile,
        setFile: (file) => {
            if (file) {
                selectedFile = file
                if (filePickerText) {
                    filePickerText.textContent = file.name
                    filePickerText.classList.remove('empty')
                }
            }
        },
        reset: () => {
            fileInput.value = ''
            selectedFile = null
            if (filePickerText) {
                filePickerText.textContent = placeholder
                filePickerText.classList.add('empty')
            }
        },
        setDisabled: (isDisabled) => {
            fileInput.disabled = isDisabled
            if (isDisabled) {
                wrapper.classList.add('disabled')
                wrapper.style.pointerEvents = 'none'
                if (filePickerSuffix) {
                    filePickerSuffix.style.pointerEvents = 'none'
                    filePickerSuffix.style.opacity = '0.5'
                }
            } else {
                wrapper.classList.remove('disabled')
                wrapper.style.pointerEvents = 'auto'
                if (filePickerSuffix) {
                    filePickerSuffix.style.pointerEvents = 'auto'
                    filePickerSuffix.style.opacity = '1'
                }
            }
        },
    }
}
